import { SvgIcon, SvgIconProps } from "@mui/material";

export const TrendingTitleIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.252 12.459V19.2451H2.75195V12.459H21.252ZM21.252 7.62012V9.70996H2.75195V7.62012H21.252Z"
        stroke="#008B07"
        strokeWidth="1.5"
      />
    </SvgIcon>
  );
};

export const TopServiceProvidersTitleIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.2827 3.45332C11.5131 2.98638 11.6284 2.75291 11.7848 2.67831C11.9209 2.61341 12.0791 2.61341 12.2152 2.67831C12.3717 2.75291 12.4869 2.98638 12.7174 3.45332L14.9041 7.88328C14.9721 8.02113 15.0061 8.09006 15.0558 8.14358C15.0999 8.19096 15.1527 8.22935 15.2113 8.25662C15.2776 8.28742 15.3536 8.29854 15.5057 8.32077L20.397 9.03571C20.9121 9.11099 21.1696 9.14863 21.2888 9.27444C21.3925 9.38389 21.4412 9.5343 21.4215 9.68377C21.3988 9.85558 21.2124 10.0372 20.8395 10.4004L17.3014 13.8464C17.1912 13.9538 17.136 14.0076 17.1004 14.0715C17.0689 14.128 17.0487 14.1902 17.0409 14.2545C17.0321 14.3271 17.0451 14.403 17.0711 14.5547L17.906 19.4221C17.994 19.9355 18.038 20.1922 17.9553 20.3445C17.8833 20.477 17.7554 20.57 17.6071 20.5975C17.4366 20.6291 17.2061 20.5078 16.7451 20.2654L12.3724 17.9658C12.2361 17.8942 12.168 17.8584 12.0962 17.8443C12.0327 17.8318 11.9673 17.8318 11.9038 17.8443C11.832 17.8584 11.7639 17.8942 11.6277 17.9658L7.25492 20.2654C6.79392 20.5078 6.56341 20.6291 6.39297 20.5975C6.24468 20.57 6.11672 20.477 6.04474 20.3445C5.962 20.1922 6.00603 19.9355 6.09407 19.4221L6.92889 14.5547C6.95491 14.403 6.96793 14.3271 6.95912 14.2545C6.95132 14.1902 6.93111 14.128 6.89961 14.0715C6.86402 14.0076 6.80888 13.9538 6.69859 13.8464L3.16056 10.4004C2.78766 10.0372 2.60121 9.85558 2.57853 9.68377C2.55879 9.5343 2.60755 9.38389 2.71125 9.27444C2.83044 9.14863 3.08797 9.11099 3.60304 9.03571L8.49431 8.32077C8.64642 8.29854 8.72248 8.28742 8.78872 8.25662C8.84736 8.22935 8.90016 8.19096 8.94419 8.14358C8.99391 8.09006 9.02793 8.02113 9.09597 7.88328L11.2827 3.45332Z"
        stroke="#008B07"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ArrowRightButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4 12H20M20 12L14 6M20 12L14 18"
        stroke="#008B07"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const SliderArrowRightIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "25", height: "24", fill: "none" }}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9775 13.5563H3.42383V10.4423H15.9775L11.1628 5.31522L13.2306 3.11328L21.5752 11.9993L13.2306 20.8853L11.1628 18.6833L15.9775 13.5563Z"
        fill="#008B07"
      />
    </SvgIcon>
  );
};

export const SliderArrowLeftIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "25", height: "24", fill: "none" }}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.62155 10.5001H21.5002V13.5001H8.62155L13.5609 18.4395L11.4396 20.5608L2.87891 12.0001L11.4396 3.43945L13.5609 5.56077L8.62155 10.5001Z"
        fill="#008B07"
      />
    </SvgIcon>
  );
};

export const ServiceProviderRatingIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "16", height: "16", fill: "none" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.99993 2.56567L9.76565 6.14282L13.7142 6.71653L10.8571 9.50167L11.5314 13.4342L7.99993 11.5782L4.4685 13.4342L5.14279 9.50167L2.28564 6.71653L6.23422 6.14282L7.99993 2.56567Z"
        fill="#FFD233"
      />
    </SvgIcon>
  );
};

export const ExpiryIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path d="M10 5.625V10H14.375" stroke="#E34444" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M10 16.875C13.797 16.875 16.875 13.797 16.875 10C16.875 6.20304 13.797 3.125 10 3.125C6.20304 3.125 3.125 6.20304 3.125 10C3.125 13.797 6.20304 16.875 10 16.875Z"
        stroke="#E34444"
        strokeWidth="1.3"
        strokeMiterlimit="10"
      />
      <path
        d="M15.3032 2.04492L17.9549 4.69657"
        stroke="#E34444"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.04492 4.69657L4.69657 2.04492"
        stroke="#E34444"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const CompletedJobsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="#A1A5B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ServiceDeliveryIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M12 20V10" stroke="#A1A5B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18 20V4" stroke="#A1A5B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 20V16" stroke="#A1A5B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};

export const PreferredAgeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8.25 15C10.9424 15 13.125 12.8174 13.125 10.125C13.125 7.43261 10.9424 5.25 8.25 5.25C5.55761 5.25 3.375 7.43261 3.375 10.125C3.375 12.8174 5.55761 15 8.25 15Z"
        stroke="#A1A5B3"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M14.5698 5.43173C15.2403 5.24281 15.9436 5.19978 16.6321 5.30552C17.3207 5.41126 17.9786 5.66333 18.5615 6.04475C19.1444 6.42616 19.6389 6.92807 20.0115 7.51666C20.3841 8.10525 20.6263 8.76685 20.7217 9.45692C20.8171 10.147 20.7635 10.8495 20.5645 11.5171C20.3655 12.1847 20.0258 12.8019 19.5682 13.3272C19.1107 13.8524 18.5458 14.2735 17.9118 14.5621C17.2777 14.8507 16.5892 15.0001 15.8926 15.0001"
        stroke="#A1A5B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.49951 18.5059C2.26089 17.4229 3.27166 16.539 4.4465 15.9288C5.62133 15.3186 6.92574 15.0001 8.24959 15C9.57344 14.9999 10.8779 15.3184 12.0528 15.9285C13.2276 16.5386 14.2385 17.4225 14.9999 18.5054"
        stroke="#A1A5B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8926 15C17.2166 14.999 18.5213 15.3171 19.6962 15.9273C20.8712 16.5375 21.8819 17.4218 22.6426 18.5054"
        stroke="#A1A5B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ServiceRequestedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18", height: "18", fill: "none" }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path d="M7.5 7.5H13.5" stroke="#A1A5B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.5 10.5H13.5" stroke="#A1A5B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M16.5 0.75H1.5C1.08579 0.75 0.75 1.08579 0.75 1.5V16.5C0.75 16.9142 1.08579 17.25 1.5 17.25H16.5C16.9142 17.25 17.25 16.9142 17.25 16.5V1.5C17.25 1.08579 16.9142 0.75 16.5 0.75Z"
        stroke="#A1A5B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4.5 0.75V17.25" stroke="#A1A5B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};

export const ServiceLocationIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
        stroke="#A1A5B3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22C16 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 8 18 12 22Z"
        stroke="#A1A5B3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const CopyIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15.75 15.7495H20.25V3.74951H8.25V8.24951"
        stroke="#008B07"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 8.24951H3.75V20.2495H15.75V8.24951Z"
        stroke="#008B07"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const FacebookIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.3308 3.32083H15.1566V0.140833C14.8416 0.0975 13.7583 0 12.4966 0C9.86409 0 8.06076 1.65583 8.06076 4.69917V7.5H5.15576V11.055H8.06076V20H11.6224V11.0558H14.4099L14.8524 7.50083H11.6216V5.05167C11.6224 4.02417 11.8991 3.32083 13.3308 3.32083Z"
        fill="#008B07"
      />
    </SvgIcon>
  );
};

export const TwitterIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M20 3.79875C19.2563 4.125 18.4637 4.34125 17.6375 4.44625C18.4875 3.93875 19.1363 3.14125 19.4412 2.18C18.6488 2.6525 17.7738 2.98625 16.8412 3.1725C16.0887 2.37125 15.0162 1.875 13.8462 1.875C11.5763 1.875 9.74875 3.7175 9.74875 5.97625C9.74875 6.30125 9.77625 6.61375 9.84375 6.91125C6.435 6.745 3.41875 5.11125 1.3925 2.6225C1.03875 3.23625 0.83125 3.93875 0.83125 4.695C0.83125 6.115 1.5625 7.37375 2.6525 8.1025C1.99375 8.09 1.3475 7.89875 0.8 7.5975C0.8 7.61 0.8 7.62625 0.8 7.6425C0.8 9.635 2.22125 11.29 4.085 11.6712C3.75125 11.7625 3.3875 11.8062 3.01 11.8062C2.7475 11.8062 2.4825 11.7913 2.23375 11.7362C2.765 13.36 4.2725 14.5538 6.065 14.5925C4.67 15.6838 2.89875 16.3412 0.98125 16.3412C0.645 16.3412 0.3225 16.3263 0 16.285C1.81625 17.4563 3.96875 18.125 6.29 18.125C13.835 18.125 17.96 11.875 17.96 6.4575C17.96 6.27625 17.9538 6.10125 17.945 5.9275C18.7588 5.35 19.4425 4.62875 20 3.79875Z"
        fill="#008B07"
      />
    </SvgIcon>
  );
};

export const EmailIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21 5.25L12 13.5L3 5.25"
        stroke="#008B07"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 5.25H21V18C21 18.1989 20.921 18.3897 20.7803 18.5303C20.6397 18.671 20.4489 18.75 20.25 18.75H3.75C3.55109 18.75 3.36032 18.671 3.21967 18.5303C3.07902 18.3897 3 18.1989 3 18V5.25Z"
        stroke="#008B07"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3638 12L3.23145 18.538"
        stroke="#008B07"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.7687 18.5381L13.6362 12"
        stroke="#008B07"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const WhatsAppIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_31038_929)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.6324 3.34007C14.8783 1.58386 12.5454 0.616264 10.0601 0.615234C4.93885 0.615234 0.770912 4.78306 0.768852 9.90566C0.768166 11.5432 1.19595 13.1417 2.00905 14.5507L0.690918 19.3652L5.61634 18.0732C6.97349 18.8135 8.5014 19.2036 10.0563 19.2041H10.0602C15.1809 19.2041 19.3492 15.0359 19.3512 9.9131C19.3522 7.43042 18.3867 5.09617 16.6324 3.34007ZM10.0601 17.635H10.0569C8.67123 17.6344 7.31224 17.262 6.1264 16.5586L5.84454 16.3911L2.92171 17.1579L3.70186 14.3082L3.51818 14.016C2.74513 12.7865 2.33692 11.3654 2.33761 9.90623C2.33921 5.64846 5.80357 2.18445 10.0632 2.18445C12.1259 2.18513 14.0648 2.98943 15.5228 4.44912C16.9808 5.90881 17.7832 7.84904 17.7826 9.91253C17.7807 14.1706 14.3166 17.635 10.0601 17.635ZM14.296 11.8513C14.0639 11.735 12.9225 11.1736 12.7096 11.096C12.497 11.0185 12.342 10.9799 12.1874 11.2122C12.0326 11.4445 11.5878 11.9675 11.4523 12.1224C11.3168 12.2773 11.1815 12.2968 10.9493 12.1805C10.7171 12.0644 9.9691 11.8191 9.0823 11.0282C8.39222 10.4126 7.92633 9.6524 7.79083 9.42009C7.65556 9.18754 7.78969 9.07402 7.89268 8.9463C8.144 8.63422 8.39565 8.30704 8.47301 8.1522C8.55049 7.99724 8.51169 7.86163 8.45356 7.74547C8.39565 7.62932 7.93137 6.48662 7.73796 6.02165C7.54936 5.56915 7.35813 5.63026 7.21554 5.62317C7.08027 5.61642 6.92543 5.61504 6.77059 5.61504C6.61587 5.61504 6.36433 5.67306 6.15147 5.90561C5.93872 6.13804 5.33905 6.6996 5.33905 7.84229C5.33905 8.98498 6.17092 10.0889 6.28696 10.2438C6.40301 10.3988 7.92404 12.7437 10.2528 13.7492C10.8067 13.9886 11.2391 14.1313 11.5763 14.2383C12.1325 14.415 12.6384 14.39 13.0385 14.3303C13.4846 14.2636 14.4119 13.7686 14.6056 13.2264C14.799 12.6841 14.799 12.2193 14.7408 12.1224C14.6829 12.0256 14.5281 11.9675 14.296 11.8513Z"
          fill="#008B07"
        />
      </g>
      <defs>
        <clipPath id="clip0_31038_929">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const StarReviewsTitleIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "16", height: "16", fill: "none" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.49114 1.4668C7.67947 1.01399 8.32094 1.014 8.50927 1.46681L10.0583 5.1912C10.1377 5.38209 10.3173 5.51252 10.5233 5.52905L14.5441 5.85139C15.033 5.89058 15.2312 6.50063 14.8587 6.81965L11.7953 9.44385C11.6383 9.57832 11.5697 9.78939 11.6177 9.99045L12.5537 13.9141C12.6675 14.3911 12.1485 14.7681 11.73 14.5125L8.2876 12.4099C8.1112 12.3022 7.88927 12.3022 7.71287 12.4099L4.27047 14.5125C3.85196 14.7681 3.33301 14.3911 3.4468 13.9141L4.38272 9.99045C4.4307 9.78939 4.36212 9.57832 4.20511 9.44385L1.14168 6.81965C0.769236 6.50063 0.967456 5.89058 1.4563 5.85139L5.4771 5.52905C5.68318 5.51252 5.8627 5.38209 5.9421 5.1912L7.49114 1.4668Z"
        fill="#F3BC4E"
      />
    </SvgIcon>
  );
};

export const StarFilledIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.3446 15.401L14.2849 17.8974C14.7886 18.2165 15.4139 17.7419 15.2644 17.154L14.126 12.6756C14.0939 12.5509 14.0977 12.4197 14.137 12.297C14.1762 12.1743 14.2492 12.0652 14.3477 11.9822L17.8811 9.04132C18.3453 8.6549 18.1057 7.88439 17.5092 7.84567L12.8949 7.5462C12.7706 7.53732 12.6514 7.49332 12.5511 7.41931C12.4509 7.34531 12.3737 7.24435 12.3286 7.12819L10.6076 2.79436C10.5609 2.67106 10.4777 2.56492 10.3692 2.49002C10.2606 2.41511 10.1319 2.375 10 2.375C9.86813 2.375 9.73938 2.41511 9.63085 2.49002C9.52232 2.56492 9.43914 2.67106 9.39236 2.79436L7.6714 7.12819C7.62631 7.24435 7.54914 7.34531 7.4489 7.41931C7.34865 7.49332 7.22944 7.53732 7.10515 7.5462L2.49078 7.84567C1.89429 7.88439 1.65466 8.6549 2.11894 9.04132L5.65232 11.9822C5.75079 12.0652 5.82383 12.1743 5.86305 12.297C5.90226 12.4197 5.90606 12.5509 5.874 12.6756L4.81824 16.8288C4.63889 17.5343 5.38929 18.1038 5.99369 17.7209L9.65539 15.401C9.75837 15.3354 9.87792 15.3006 10 15.3006C10.1221 15.3006 10.2416 15.3354 10.3446 15.401Z"
        fill="#FD8E1F"
      />
    </SvgIcon>
  );
};

export const StarEmptyIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 2.97461C10.01 2.97461 10.02 2.97775 10.0283 2.9834C10.0366 2.9891 10.0433 2.99748 10.0469 3.00684L10.0498 3.01562L11.7705 7.34961V7.34863C11.8569 7.56933 12.0036 7.76153 12.1943 7.90234C12.386 8.04386 12.6149 8.12755 12.8525 8.14453H12.8564L17.4707 8.44434C17.4886 8.44555 17.4939 8.45048 17.4971 8.45312C17.5033 8.45845 17.5131 8.47068 17.5195 8.49121C17.526 8.51196 17.5259 8.53095 17.5225 8.54395C17.5199 8.5535 17.5148 8.56533 17.4971 8.58008L13.9639 11.5215L13.9609 11.5234C13.7761 11.6792 13.639 11.884 13.5654 12.1143C13.4918 12.3445 13.4848 12.5911 13.5449 12.8252V12.8242L14.6826 17.3018C14.6896 17.3294 14.6859 17.3446 14.6826 17.3535C14.6782 17.3653 14.6699 17.378 14.6572 17.3877C14.6444 17.3974 14.6336 17.4001 14.6299 17.4004C14.6284 17.4005 14.627 17.3999 14.625 17.3994C14.623 17.3989 14.6166 17.397 14.6064 17.3906L10.666 14.8945H10.667C10.4677 14.7677 10.2362 14.7002 10 14.7002C9.76378 14.7002 9.53227 14.7677 9.33301 14.8945L5.67285 17.2139C5.6301 17.241 5.59668 17.2459 5.57129 17.2441C5.54211 17.2421 5.50751 17.23 5.47461 17.2051C5.41043 17.1563 5.37381 17.0773 5.39941 16.9766L6.4541 12.8242L6.45508 12.8252C6.51525 12.5911 6.50818 12.3445 6.43457 12.1143C6.36096 11.884 6.22387 11.6792 6.03906 11.5234L6.03613 11.5215L2.50293 8.58008C2.4852 8.56533 2.48006 8.5535 2.47754 8.54395C2.47414 8.53095 2.47402 8.51196 2.48047 8.49121C2.4869 8.47068 2.49671 8.45845 2.50293 8.45312C2.50606 8.45048 2.51138 8.44555 2.5293 8.44434L7.14355 8.14453H7.14746C7.38513 8.12755 7.61396 8.04386 7.80566 7.90234C7.99626 7.7616 8.14211 7.56919 8.22852 7.34863L8.22949 7.34961L9.9502 3.01562L9.95312 3.00684C9.95673 2.99747 9.96342 2.9891 9.97168 2.9834C9.97997 2.97774 9.98996 2.97461 10 2.97461Z"
        stroke="#FD8E1F"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ArrowBackButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M19 12H5M5 12L11 6M5 12L11 18" stroke="#111111" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const SelectArrowDownIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.20711 10C6.76165 10 6.53857 10.5386 6.85355 10.8536L12 16L17.1464 10.8536C17.4614 10.5386 17.2383 10 16.7929 10L7.20711 10Z"
        fill="#111111"
      />
    </SvgIcon>
  );
};

export const CalendarIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18", height: "18", fill: "none" }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M2 3H16C16.5523 3 17 3.44771 17 4V16C17 16.5523 16.5523 17 16 17H2C1.44772 17 1 16.5523 1 16V4C1 3.44772 1.44772 3 2 3Z"
        stroke="#111111"
        strokeWidth="2"
      />
      <path d="M1 8H17" stroke="#111111" strokeWidth="2" />
      <path d="M14 1C14 0.447715 13.5523 0 13 0C12.4477 0 12 0.447715 12 1H14ZM13 3H14V1H13H12V3H13Z" fill="#111111" />
      <path d="M6 1C6 0.447715 5.55228 0 5 0C4.44772 0 4 0.447715 4 1H6ZM5 3H6V1H5H4V3H5Z" fill="#111111" />
    </SvgIcon>
  );
};

export const MilestonePinningStepperIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "32", height: "32", fill: "none" }}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <rect x="1" y="1" width="30" height="30" rx="15" stroke="#EAECF0" strokeWidth="2" />
      <circle cx="16" cy="16" r="5" fill="#EAECF0" />
    </SvgIcon>
  );
};

export const MilestoneActiveStepperIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "32", height: "32", fill: "none" }}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <rect x="1" y="1" width="30" height="30" rx="15" fill="#E7EFED" />
      <rect x="1" y="1" width="30" height="30" rx="15" stroke="#008B07" strokeWidth="2" />
      <circle cx="16" cy="16" r="5" fill="#008B07" />
    </SvgIcon>
  );
};

export const MilestonePaidStepperIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "32", height: "32", fill: "none" }}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <rect x="1" y="1" width="30" height="30" rx="15" stroke="#008B07" strokeWidth="2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7953 9.8542L13.2487 19.0675L10.7153 16.3609C10.2487 15.9209 9.51534 15.8942 8.982 16.2675C8.462 16.6542 8.31534 17.3342 8.63534 17.8809L11.6353 22.7609C11.9287 23.2142 12.4353 23.4942 13.0087 23.4942C13.5553 23.4942 14.0753 23.2142 14.3687 22.7609C14.8487 22.1342 24.0087 11.2142 24.0087 11.2142C25.2087 9.98753 23.7553 8.90753 22.7953 9.84086V9.8542Z"
        fill="#008B07"
      />
    </SvgIcon>
  );
};
